export const LOAN_DETAILS_TABS = [
  'form1008',
  'team',
  'pricing',
  'approval',
  'loanEstimate',
  'delivery',
  'compensation',
  'docorder',
  'fraudAlerts',
  'appraisal',
  'communications'
] as const;

export type LoanDetailsTab = typeof LOAN_DETAILS_TABS[number];

const LOAN_DETAILS_TAB_SET = new Set<string>(LOAN_DETAILS_TABS);

export interface LoanCenterDeepLink {
  loanId: string;
  tab: LoanDetailsTab;
  reportId?: string;
}

export function parseLoanCenterDeepLink(search: string): LoanCenterDeepLink | null {
  const params = new URLSearchParams(search);
  const loanId = params.get('loan')?.trim();
  if (!loanId) {
    return null;
  }

  const requestedTab = params.get('tab')?.trim() ?? '';
  const tab = LOAN_DETAILS_TAB_SET.has(requestedTab)
    ? requestedTab as LoanDetailsTab
    : 'form1008';

  const reportId = params.get('report')?.trim();
  const validReport = tab === 'appraisal' && reportId && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(reportId);
  return { loanId, tab, ...(validReport ? { reportId } : {}) };
}

export function loanCenterInternalPath(search: string): string {
  const params = new URLSearchParams(search);
  params.set('section', 'loan-center');
  return `/internal?${params.toString()}`;
}
